import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { FeatureContainer } from '../Containers/FeatureContainer';
import { RelaisMainInfoFragment } from '../../../graphql/generated/graphql';
import { NotificationsEntry } from 'components/atoms/Notifications/NotificationsEntry';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { SelectedPointRelais } from '../../../store/selectors/client.selectors';
import { useStyles } from './map.style';

interface LeafletMapProps {
  markers: {
    lat: number;
    long: number;
    name: string;
    data: RelaisMainInfoFragment;
  }[];
  handleClick?: (e: unknown) => void;
  selectedMarker: SelectedPointRelais;
}

const LeafletMap = ({
  markers,
  handleClick,
  selectedMarker
}: LeafletMapProps) => {
  const classes = useStyles();
  const tileLayerProps = {
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  };
  return (
    <MapContainer
      className={classes.map}
      center={[markers[0].lat, markers[0].long]}
      zoom={14}
      scrollWheelZoom={false}
    >
      <TileLayer {...tileLayerProps} />
      {markers.map((marker, i) => (
        <Marker key={i} position={[marker.lat, marker.long]}>
          <Popup>
            <FeatureContainer padding="small">
              <NotificationsEntry contentText={marker.name} />
              <ButtonWithText
                variant={
                  selectedMarker.relaisid === marker.data.identifiant
                    ? 'primaryGreen'
                    : 'secondaryGreen'
                }
                onClick={() => handleClick(marker.data)}
                content={
                  selectedMarker.relaisid === marker.data.identifiant
                    ? 'Sélectionné ✔️'
                    : 'Sélectionner ?'
                }
              />
            </FeatureContainer>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};
export default LeafletMap;
